import {
  DrawerHeader,
  DrawerHeaderProps,
  useDrawerContext,
} from '@chakra-ui/react';
import { forwardRef } from 'react';

/*
 * v2's `DrawerHeader` labelled the drawer automatically. v3's is a plain div,
 * and the dialog machine only sets `aria-labelledby` once an element carrying
 * its title id is rendered (normally `Drawer.Title`). Giving the header that
 * id keeps v2's accessible name without wrapping every header in a title —
 * same approach as `MCenterModal`. A root `ids.title` is respected, and as in
 * v2 a caller-supplied `id` wins.
 *
 * v2's header was also a `<header>` element, which QA's e2e suite reads as the
 * drawer's banner (`getByRole('dialog').getByRole('banner')`); v3's div broke
 * that, so it is rendered as one again.
 */
const MDrawerHeader = forwardRef<HTMLDivElement, DrawerHeaderProps>(
  (props, ref) => {
    const { getTitleProps } = useDrawerContext();

    return (
      <DrawerHeader ref={ref} as="header" id={getTitleProps().id} {...props} />
    );
  },
);

MDrawerHeader.displayName = 'MDrawerHeader';

export default MDrawerHeader;
